var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTablet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.45087 3.28169C5.76131 3.28169 5.20231 3.87759 5.20231 4.61268V20.3873C5.20231 21.1224 5.76131 21.7183 6.45087 21.7183H17.5491C18.2387 21.7183 18.7977 21.1224 18.7977 20.3873V4.61268C18.7977 3.87759 18.2387 3.28169 17.5491 3.28169H6.45087ZM4 4.61268C4 3.16974 5.09729 2 6.45087 2H17.5491C18.9027 2 20 3.16974 20 4.61268V20.3873C20 21.8303 18.9027 23 17.5491 23H6.45087C5.09729 23 4 21.8303 4 20.3873V4.61268Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21C12.5523 21 13 20.5523 13 20C13 19.4477 12.5523 19 12 19C11.4477 19 11 19.4477 11 20C11 20.5523 11.4477 21 12 21Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablet);
export default __webpack_public_path__ + "static/media/tablet.63b73dbc.svg";
export { ForwardRef as ReactComponent };